import { createReducer } from '@reduxjs/toolkit';

import getCarMakeList from '../../thunks/general/getCarMakeList';

const initialState = {
  loading: false,
  error: null,
  list: [],
  total: 0
};

const getCarMakeListReducer = createReducer(initialState, {
  [getCarMakeList.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getCarMakeList.fulfilled]: (state, { payload: { data, total } }) => ({
    ...state,
    list: data.map(({ make }) => ({ label: make, value: make })),
    loading: false,
    total
  }),
  [getCarMakeList.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getCarMakeListReducer;
